var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inertia-link',{staticStyle:{"color":"inherit"},attrs:{"href":_vm.href}},[_c('text-ellipsis',_vm._b({},'text-ellipsis',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }